import { COMPARE_KEYS } from "../../../constants/global.constants";

import { unitConverter } from "../../../utils/Utils";
import { formatUnitForDisplay } from "../../../utils/Utils";
import { getDerivedNwpUnitFromFlow } from "../../../utils/Utils";

export const FIELD_RELATIONSHIPS = {
  startup_pressure_drop: {
    targetField: "max_pressure_drop",
    conversion: (value) =>
      value === 0 ? 0 : parseFloat((value * 2).toFixed(2)),
    compareKey: COMPARE_KEYS.GREATER,
  },
  designed_permeate_flow: {
    targetField: "min_permeate_flow",
    conversion: (value) =>
      value === 0 ? 0 : parseFloat((value * 0.6).toFixed(2)),
    compareKey: COMPARE_KEYS.LESS,
  },
};

export const REPLACEMENT_THRESHOLD = (unitSettings) => {
  const getReplacementThresholdConfig = (min, max, isRequired, unit) => ({
    ranges: {
      hard: {
        min,
        max: unitSettings[unit] ? unitConverter(max, unitSettings[unit]) : max,
      },
    },
    isRequired,
    unitLabel: formatUnitForDisplay(unitSettings[unit] || unit),
  });

  const config = {
    max_feed_pressure: getReplacementThresholdConfig(
      0.01,
      1000,
      true,
      "pressure",
    ),
    max_permeate_quality: getReplacementThresholdConfig(
      0.01,
      10000,
      true,
      "permeate_quality",
    ),
    std_warranty_period: getReplacementThresholdConfig(0.01, 20, true, "yrs"),
    startup_pressure_drop: getReplacementThresholdConfig(
      0.01,
      20,
      true,
      "pressure",
    ),
    designed_permeate_flow: getReplacementThresholdConfig(
      0.01,
      10000,
      true,
      "flow",
    ),
    std_membrane_age: getReplacementThresholdConfig(0.01, 20, true, "yrs"),
    max_pressure_drop: getReplacementThresholdConfig(
      0.01,
      null,
      true,
      "pressure",
    ),
    min_permeate_flow: getReplacementThresholdConfig(0.01, null, true, "flow"),
    nwp_trigger: getReplacementThresholdConfig(
      0.001,
      5,
      true,
      getDerivedNwpUnitFromFlow(unitSettings.flow),
    ),
  };

  Object.keys(FIELD_RELATIONSHIPS).forEach((relationshipKey) => {
    const relationship = FIELD_RELATIONSHIPS[relationshipKey];
    const targetField = relationship.targetField;
    config[targetField].ranges = {
      hard: {
        min: config[relationshipKey].ranges.hard.min,
        max: relationship.conversion(config[relationshipKey].ranges.hard.max),
      },
    };
  });
  return config;
};
